import router from '@/router'
import { JWTService } from '@/shared/services/jwt'
import ClientFactory from '@/shared/factories/client'

const config = {
  baseURL: process.env.APIBaseBPM,
  headers: { 'Content-Type': 'multipart/form-data' }
}

const APIClient = ClientFactory.New(config)

APIClient.interceptors.request.use((request) => {
  const token = JWTService.GetToken()

  /* eslint-disable-next-line */
  // if (token) request.headers.Authorization = `Bearer ${JWTService.GetToken()}`
  if (token) request.headers.Authorization = `${JWTService.GetToken()}`

  return request
}, error => Promise.reject(error))

APIClient.interceptors.response.use(response => response, (error) => {
  if (error.response.status.toString().match(/4\d[13]/)) {
    JWTService.DestroyToken()
    router.replace({ name: 'SignIn' })
  }
  return Promise.reject(error)
})

export default APIClient



// WEBPACK FOOTER //
// ./src/shared/http/clients/apiupload.js